<template>
	<div class="sl">
		<div v-if="!slides.length" class="sl-empty">Nessuna slide: caricane una qui sotto o scegli un prodotto.</div>

		<!-- le slide: si riordinano trascinando la maniglia -->
		<draggable :list="slides.slice()" handle=".sl-grab" class="sl-list" @change="$emit('sposta', $event)">
			<div v-for="(item, index) in slides" :key="chiave(item, index)" class="sl-slide">
				<div class="sl-side">
					<v-icon class="sl-grab" title="Trascina per cambiare l'ordine">mdi-drag</v-icon>
					<span class="sl-n">{{ index + 1 }}</span>
				</div>
				<div class="sl-thumb">
					<img v-if="immagine(item)" :src="immagine(item)" alt="" loading="lazy" />
					<v-icon v-else color="grey lighten-1">mdi-image-off-outline</v-icon>
				</div>
				<div class="sl-main">
					<div class="sl-langs">
						<button v-for="t in item.trans" :key="t.lang" type="button" class="sl-lang" :class="{ 'sl-lang--on': linguaDi(index, item) === t.lang }" @click="$set(lingue, index, t.lang)">
							<img :src="bandiera(t.lang)" :alt="t.lang" />{{ String(t.lang).toUpperCase() }}
						</button>
						<v-spacer></v-spacer>
						<v-select
							:value="item.position || 'slider'"
							:items="posizioni"
							label="Posizione"
							title="Nel tema Forge: nello slider in alto oppure come banner a centro pagina"
							outlined
							dense
							hide-details
							class="sl-position"
							@change="$set(item, 'position', $event)"
						/>
						<v-switch v-model="item.fullscreen" label="A tutto schermo" color="primary" dense hide-details class="mt-0 pt-0 sl-switch" />
						<v-btn icon small title="Togli questa slide" @click="$emit('elimina', index)"><v-icon small>mdi-delete-outline</v-icon></v-btn>
					</div>
					<template v-for="t in item.trans">
						<v-row v-if="linguaDi(index, item) === t.lang" :key="t.lang" class="sl-fields">
							<v-col cols="12" md="3">
								<v-text-field v-model="t.badge" label="Etichetta (facoltativa)" placeholder="Es. Fino al 2 novembre" prepend-inner-icon="mdi-label-outline" outlined dense hide-details />
							</v-col>
							<v-col cols="12" md="3"><v-text-field v-model="t.name" label="Titolo" outlined dense hide-details /></v-col>
							<v-col cols="12" md="3"><v-text-field v-model="t.text" label="Testo" outlined dense hide-details /></v-col>
							<v-col cols="12" md="3">
								<v-text-field v-if="urlDi(item, t.lang)" v-model="urlDi(item, t.lang).url" label="Link" placeholder="https://" prepend-inner-icon="mdi-link-variant" outlined dense hide-details />
							</v-col>
						</v-row>
					</template>
				</div>
			</div>
		</draggable>

		<!-- aggiungere una slide: immagine caricata oppure prodotto -->
		<div class="sl-add">
			<div class="sl-section">Aggiungi una slide</div>
			<v-row class="sl-fields">
				<v-col cols="12" md="6">
					<vue-dropzone
						id="dropzoneslider"
						ref="dropzoneSlider"
						:options="dropzoneOptions"
						:use-custom-slot="true"
						@vdropzone-complete="f => $emit('caricato', f)"
						@vdropzone-sending="(f, x, d) => $emit('invio', f, x, d)"
					>
						<div class="sl-drop-text">
							<v-icon color="primary">mdi-image-plus</v-icon>
							<div><strong>Trascina qui un'immagine</strong> o clicca per sceglierla</div>
							<div class="sl-muted">JPG, GIF o PNG</div>
						</div>
					</vue-dropzone>
				</v-col>
				<v-col cols="12" md="6">
					<div class="sl-or">oppure parti da un prodotto</div>
					<v-autocomplete
						:value="searchproduct"
						:search-input="searchitem"
						:items="listitems"
						:loading="isLoading"
						outlined
						dense
						clearable
						hide-details
						hide-selected
						no-filter
						return-object
						item-value="variants.sku"
						label="Cerca il prodotto (almeno 3 lettere)"
						prepend-inner-icon="mdi-magnify"
						:menu-props="{ offsetY: true, maxHeight: 360 }"
						@input="$emit('update:searchproduct', $event)"
						@update:search-input="$emit('update:searchitem', $event)"
					>
						<template #no-data>
							<v-list-item>
								<v-list-item-title class="sl-muted">Scrivi il nome o il codice del prodotto</v-list-item-title>
							</v-list-item>
						</template>
						<template #selection="{ item }">
							<span class="sl-sel">{{ item.trans.name }}</span>
						</template>
						<template #item="{ item }">
							<v-list-item-avatar rounded size="44" tile>
								<v-img :src="createImage(item)" contain />
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title>{{ item.trans.name }}</v-list-item-title>
								<v-list-item-subtitle>{{ item.variants.sku }}</v-list-item-subtitle>
								<v-list-item-subtitle v-if="item.variants.variants && item.variants.variants.length">
									{{ item.variants.variants.map(el => `${el.name.trans}: ${el.value.trans}`).join(' · ') }}
								</v-list-item-subtitle>
							</v-list-item-content>
						</template>
					</v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import Draggable from 'vuedraggable';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

/*
 * Le slide della home. I dati e le operazioni restano in Layout.vue: qui si modificano i campi
 * della slide (form.layout.slider) e si emettono gli eventi per spostare, togliere e aggiungere.
 * Come prima, draggable lavora su una copia della lista e lo spostamento vero lo fa il genitore (sposta).
 */
export default {
	name: 'SliderHome',
	components: { Draggable, vueDropzone: vue2Dropzone },
	props: {
		form: { type: Object, required: true },
		dropzoneOptions: { type: Object, required: true },
		listitems: { type: Array, default: () => [] },
		isLoading: { type: Boolean, default: false },
		searchitem: { type: String, default: '' },
		searchproduct: { type: [Object, String], default: '' },
		createImage: { type: Function, required: true },
	},
	data() {
		// lingua mostrata per ogni slide (indice -> lang)
		return {
			lingue: {},
			// dove va la slide nella home Forge (campo position della slide; vuoto = slider)
			posizioni: [
				{ text: 'Slider in alto', value: 'slider' },
				{ text: 'Banner a centro pagina', value: 'center' },
			],
		};
	},
	computed: {
		slides() {
			return (this.form.layout && this.form.layout.slider) || [];
		},
	},
	methods: {
		chiave(item, index) {
			const img = this.immagine(item);
			return img ? `${img}-${index}` : index;
		},
		immagine(item) {
			return (item.sizes && item.sizes[0] && item.sizes[0].value) || '';
		},
		linguaDi(index, item) {
			return this.lingue[index] || (item.trans && item.trans[0] && item.trans[0].lang);
		},
		urlDi(item, lang) {
			return (item.url || []).find(u => u.lang === lang);
		},
		bandiera(lang) {
			try {
				return require(`@/assets/images/flag/${String(lang).toUpperCase()}.svg`);
			} catch (e) {
				return require('@/assets/images/flag/map.svg');
			}
		},
	},
};
</script>

<style scoped>
.sl-position {
	flex: 0 0 210px;
	max-width: 210px;
	margin-right: 12px;
}
.sl-empty {
	padding: 16px;
	text-align: center;
	color: #5f6b7a;
	border: 1px dashed #c8d3e1;
	border-radius: 10px;
	margin-bottom: 12px;
}
.sl-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}
.sl-slide {
	display: flex;
	gap: 12px;
	padding: 10px;
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	background: #fff;
}
.sl-side {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	flex: 0 0 auto;
}
.sl-grab {
	cursor: grab;
	color: #8a96a3 !important;
}
.sl-n {
	font-size: 12px;
	font-weight: 700;
	color: #5f6b7a;
}
.sl-thumb {
	flex: 0 0 200px;
	width: 200px;
	height: 110px;
	border-radius: 8px;
	overflow: hidden;
	background: #f3f6fa;
	display: flex;
	align-items: center;
	justify-content: center;
}
.sl-thumb img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.sl-main {
	flex: 1 1 auto;
	min-width: 0;
}
.sl-langs {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	margin-bottom: 6px;
}
.sl-lang {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 2px 6px;
	border: 1px solid #e1e7ef;
	border-radius: 6px;
	background: #fff;
	font-size: 11px;
	font-weight: 600;
	color: #5f6b7a;
}
.sl-lang img {
	width: 16px;
	height: 12px;
	object-fit: cover;
}
.sl-lang--on {
	border-color: #01579b;
	color: #01579b;
	background: #eef4fd;
}
.sl-switch {
	margin-right: 4px;
}
.sl-switch ::v-deep .v-label {
	font-size: 12px;
}
.sl-fields {
	margin: 0;
}
.sl-fields > [class*='col'] {
	padding: 4px;
}
.sl-add {
	margin-top: 16px;
	padding-top: 12px;
	border-top: 1px solid #eef2f7;
}
.sl-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.sl-muted {
	color: #5f6b7a;
	font-size: 12px;
}
.sl-or {
	font-size: 12px;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.sl-sel {
	display: block;
	max-width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.sl-add ::v-deep .vue-dropzone {
	min-height: 96px;
	padding: 8px;
	border: 1px dashed #9fb6d3;
	border-radius: 10px;
	background: #f7faff;
}
.sl-add ::v-deep .dz-message {
	margin: 0;
}
.sl-drop-text {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2px;
	font-size: 13px;
	color: #1f2d3d;
}
@media (max-width: 768px) {
	.sl-slide {
		flex-wrap: wrap;
	}
	.sl-thumb {
		flex: 1 1 calc(100% - 40px);
		width: auto;
		height: 140px;
	}
	.sl-main {
		flex-basis: 100%;
	}
}
</style>
